/*eslint-disable*/
import $ from "jquery";
import headroom from "headroom.js";
import fancybox from "@fancyapps/fancybox";

export default {
    init() {
        // JavaScript to be fired on all pages
        // fancybox
        //$(".c-article__headline").textfill({});

        // headroom
        var header = new headroom(document.querySelector(".c-header"), {
            tolerance: 15,
            offset: 205
        });
        header.init();
        //
        function transitionClass() {
            document
                .getElementsByTagName("html")[0]
                .classList.add("transitions");
        }
        setTimeout(transitionClass, 3000);

        // js mq
        const alterClass = function() {
            const mq = 768;
            let ww = document.body.clientWidth;
            if (ww < mq) {
                $("html")
                    .removeClass("desktop-view")
                    .addClass("mobile-view");
            } else if (ww >= mq) {
                $("html")
                    .addClass("desktop-view")
                    .removeClass("mobile-view");
            }
        };
        $(window).resize(function() {
            alterClass();
        });
        setTimeout(alterClass, 500);
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        // $(".post-link").fancybox({
        var burger = document.querySelector(".burger");
        var target = document.getElementsByTagName("html")[0];
        burger.addEventListener("click", function() {
            this.classList.toggle("is-active");
            target.classList.toggle("is-open");
        });
        // });
        // $(".post-nav a").fancybox({
        //   src: $(this).data("href"),

        // });
        const btn =
            '<div data-fancybox-close class="fancybox-close-small modal-close fancybox-custom-close-btn">' +
            '<svg class="close-btn" style="float:left" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">' +
            '<path fill="#fff" fill-rule="evenodd" d="M36.395191,55 C35.6169563,54.9921899 34.9922589,54.35567 35.0000725,53.577788 C35.0035886,53.2122772 35.1493123,52.862777 35.4059891,52.602702 L47.9686971,40.0156183 L35.4059891,27.4285347 C34.9246713,26.817007 35.0305456,25.9317366 35.6419598,25.4506369 C36.15336,25.0484188 36.8733834,25.0484188 37.3847836,25.4506369 L49.9775739,38.0076518 L62.5703643,25.4205682 C63.1161443,24.8660539 64.0084576,24.8590248 64.5632233,25.4045575 C64.5686928,25.4100246 64.5737716,25.4151011 64.5792412,25.4205682 C65.1340068,25.9661009 65.1410391,26.8580098 64.595259,27.412524 C64.5897895,27.4179911 64.5847107,27.4230676 64.5792412,27.4285347 L51.9860601,40.0156183 L64.5487681,52.6023115 C64.8167746,52.8616055 64.9679678,53.2185252 64.9683585,53.5914556 C64.9605449,54.3693376 64.3237364,54.993752 63.5455017,54.9859419 C63.1798252,54.9824274 62.8301665,54.8367697 62.5699736,54.5802093 L49.9775739,42.0235848 L37.3847836,54.5802093 C37.1234186,54.8453608 36.7675091,54.996095 36.395191,55 Z" transform="translate(-35 -25)"/>' +
            "</svg>" +
            "</div>";

        $(".fancybox-close-small").on("click", function() {
            window.location.hash = "";
        });

        $(".post-issue, .post-link").on("click", function() {
            var dataId = $(this)
                .parent()
                .parent()
                .parent()
                .parent()
                .data("id");

            $("main").addClass(dataId);
        });

        $(".post-issue").fancybox({
            touch: false,
            type: "inline",
            baseClass: "fancybox-inline",
            parentEl: "main",
            beforeClose: function() {
                $("main").removeClass(function(index, className) {
                    return (className.match(/(^|\s)active-\S+/g) || []).join(
                        " "
                    );
                });
            },
            buttons: ["close"],
            smallBtn: false,
            btnTpl: {
                close: btn
            }
        });

        $(".post-link").fancybox({
            touch: false,
            type: "ajax",
            parentEl: "main",
            beforeClose: function() {
                $("main").removeClass(function(index, className) {
                    return (className.match(/(^|\s)active-\S+/g) || []).join(
                        " "
                    );
                });
            },
            buttons: ["close"],
            smallBtn: false,

            btnTpl: {
                close: btn
            },

            afterClose: function() {
                console.log("you are an even bigger motherfucker");
                $(".post-link").removeAttr("style");
            }
        });

        //$(".post-nav a").fancybox({});

        // $(".post-nav a").on("click", function() {
        //   e.preventDefault();
        //   var target = $(this).attr("href");
        //   $.get(target, function(data) {
        //     $.fancybox
        //       .getInstance()
        //       .setContent($.fancybox.getInstance().current, data);
        //   });
        // });
    }
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js